import { AxiosInstance } from "axios";
import { serviceRequest } from "@leafly-com/web-utils";
import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

// Initialize the service request with the app and environment
const reservationApi: AxiosInstance = serviceRequest(
  "global-search",
  publicRuntimeConfig.env
);

// Configure and set upstream URL
reservationApi.defaults.baseURL =
  publicRuntimeConfig.services.reservationsApi.url;
reservationApi.defaults.timeout = 5000;
reservationApi.defaults.withCredentials = true;

// Global-Search specific default headers
reservationApi.interceptors.request.use((config) => {
  config.headers["Accept"] = "application/json";
  config.headers["Content-Type"] = "application/json";

  return config;
});

export default reservationApi;
